export function misc() {
  /**
   * Assure a click on a post box will open single page
   */
  if (document.querySelector(".resource-box")) {
    document.querySelectorAll(".resource-box").forEach((box) => {
      box.addEventListener("click", (e) => {
        window.location.href = box.querySelector("a.btn").href;
      });
    });
  }

  if (document.querySelector(".job-box")) {
    document.querySelectorAll(".job-box").forEach((box) => {
      box.addEventListener("click", (e) => {
        window.location.href = box.querySelector("a.btn").href;
      });
    });
  }
}
